const _excluded = ["routes", "disableTracking"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { createErrorHandler } from '../boundaries/error';
import { pageHandler } from '../boundaries/page';
import { goToHome, openFlightSummary } from '../boundaries/flow';
import { createRouteMatcher, createFeaturesQueryRequest, aliases as reactHooksAliases, createAppProviderCoreProps } from '@edreamsodigeo/frontend-core';
import { createTrackingHandler } from '../boundaries/tracking';

// Migrated
import { aliases as manageMyBookingAliases } from '@edreamsodigeo/frontend-manage-my-booking/aliases';
import { aliases as additionsAliases } from '@edreamsodigeo/frontend-additions/aliases';
import { aliases as supportPackAliases } from '@edreamsodigeo/frontend-support-pack/aliases';
import { aliases as guaranteesAliases } from '@edreamsodigeo/frontend-guarantees/aliases';
import { aliases as feBookingAdminAliases } from '@edreamsodigeo/frontend-booking-admin/aliases';
import { aliases as priceFreezeAliases } from '@edreamsodigeo/frontend-price-freeze/aliases';

// IMPORTANT: Please, ensure your import alias is added in front_test_utils/setup.js in frontend-html5
// If the alias is not included in html5 tests, CI will fail
// https://bitbucket.org/odigeoteam/frontend-html5/pull-requests/5439
import featuresFeAccommodation from '@edreamsodigeo/frontend-accommodation/features.json';
import featuresXSelling from '@edreamsodigeo/frontend-xselling-components/features.json';
import checkoutFeatures from '@edreamsodigeo/frontend-checkout/features.json';
import checkinFeatures from '@edreamsodigeo/frontend-checkin-components/features.json';
import flightResultsFeatures from '@edreamsodigeo/frontend-flights-results/features.json';
import membershipRetentionFeatures from '@edreamsodigeo/frontend-membership-retention/features.json';
import featuresFeUserAuth from '@edreamsodigeo/frontend-user-authentication/features.json';
import shoppingBasketFeatures from '@edreamsodigeo/frontend-shopping-basket/features.json';
import featuresHomePage from '@edreamsodigeo/frontend-homepage/features.json';
import featuresMembershipStandalone from '@edreamsodigeo/frontend-membership-standalone/features.json';
import featuresPrime from '@edreamsodigeo/frontend-prime/features.json';
import featuresPrimeSubscriptionReferralFlow from '@edreamsodigeo/frontend-prime-subscription-referral-flow/features.json';
import userAreaFeatures from '@edreamsodigeo/frontend-user-area/features.json';
import { createFrontendAPIClientProps } from '../boundaries/feapiClient';
import { getAppContext } from '../boundaries/tracking/trackTime';
import { fakeABTestFeatureInputs } from '../fake_ab_tests';
import renewalPaymentMethodsFeatures from '@edreamsodigeo/frontend-renewal-payment-methods/features.json';
import insurancesFeatures from '@edreamsodigeo/frontend-insurances/features.json';
import prebookingAttractFeatures from '@edreamsodigeo/frontend-prebooking-attract/features.json';
import vehicleRentalFeatures from '@edreamsodigeo/frontend-vehicle-rental/features.json';
import seatsFeatures from '@edreamsodigeo/frontend-seats/features.json';
import cabinBagsFeatures from '@edreamsodigeo/frontend-cabin-bags/features.json';
import bagsFeatures from '@edreamsodigeo/frontend-bags/features.json';
import additionsFeatures from '@edreamsodigeo/frontend-additions/features.json';
import supportPackFeatures from '@edreamsodigeo/frontend-support-pack/features.json';
import funnelPathfinder from '@edreamsodigeo/frontend-funnel-pathfinder/features.json';
import priceFreezeFeatures from '@edreamsodigeo/frontend-price-freeze/features.json';
import ancillaryBundleFeatures from '@edreamsodigeo/frontend-ancillary-bundle/features.json';
import featuresPrimeBookingCancellation from '@edreamsodigeo/frontend-prime-booking-cancellation/features.json';
import inDestinationActivitiesFeatures from '@edreamsodigeo/frontend-in-destination-activities/features.json';
import fastTrackFeatures from '@edreamsodigeo/frontend-fast-track/features.json';
import marketingCampaignsFeatures from '@edreamsodigeo/frontend-marketing-campaigns/features.json';
import featuresPrimeSubscription from '@edreamsodigeo/frontend-prime-subscription/features.json';
import doublePaymentButtonFeature from '@edreamsodigeo/frontend-double-payment-button/features.json';
import featuresAncillariesHub from '@edreamsodigeo/frontend-ancillaries-hub/features.json';
const i18nextOptions = {
  parseMissingKeyHandler: () => ''
};
export const featureVariationsInput = createFeaturesQueryRequest([checkoutFeatures, checkinFeatures, flightResultsFeatures, featuresXSelling, featuresFeAccommodation, membershipRetentionFeatures, featuresFeUserAuth, shoppingBasketFeatures, featuresHomePage, featuresMembershipStandalone, featuresPrime, featuresPrimeSubscriptionReferralFlow, userAreaFeatures, fakeABTestFeatureInputs, renewalPaymentMethodsFeatures, insurancesFeatures, prebookingAttractFeatures, vehicleRentalFeatures, seatsFeatures, cabinBagsFeatures, bagsFeatures, additionsFeatures, supportPackFeatures, funnelPathfinder, priceFreezeFeatures, ancillaryBundleFeatures, featuresPrimeBookingCancellation, inDestinationActivitiesFeatures, fastTrackFeatures, marketingCampaignsFeatures, featuresPrimeSubscription, doublePaymentButtonFeature, featuresAncillariesHub], [reactHooksAliases, priceFreezeAliases, feBookingAdminAliases, manageMyBookingAliases, additionsAliases, supportPackAliases, guaranteesAliases]);

/**
 * @param {string} route
 * @param {object} options
 * @param {boolean} options.trigger
 * @param {boolean} options.replace
 */

const urlRouteMap = {
  '': 'homeflights',
  '/': 'homeflights'
};
const parseNextPathnameToOdigeoRoute = route => {
  return urlRouteMap[route] || route;
};
const odigeoNavigate = (route, options) => {
  window.Odigeo.Router.navigate(parseNextPathnameToOdigeoRoute(route), options);
};
export const createAppProviderProps = async (_siteConfig, _ref) => {
  var _window, _window2, _SessionScope$interfa, _window3, _window4, _window$Odigeo, _window$Odigeo2;
  let {
      routes,
      disableTracking
    } = _ref,
    optionsProps = _objectWithoutProperties(_ref, _excluded);
  const routeMatcher = createRouteMatcher(routes);
  const SessionScope = (_window = window) === null || _window === void 0 || (_window = _window.Odigeo) === null || _window === void 0 ? void 0 : _window.SessionScope;
  const flow = (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.Odigeo) === null || _window2 === void 0 || (_window2 = _window2.SessionScope) === null || _window2 === void 0 ? void 0 : _window2.flow;
  const isNativeWebView = SessionScope === null || SessionScope === void 0 || (_SessionScope$interfa = SessionScope.interface) === null || _SessionScope$interfa === void 0 ? void 0 : _SessionScope$interfa.startsWith('NATIVE_');
  const {
    brandCode,
    locale
  } = _siteConfig;
  const {
    trackSurvey,
    trackPage
  } = createTrackingHandler((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.Odigeo);
  const googleClientId = (_window4 = window) === null || _window4 === void 0 || (_window4 = _window4.Odigeo) === null || _window4 === void 0 || (_window4 = _window4.SessionScope) === null || _window4 === void 0 || (_window4 = _window4.social) === null || _window4 === void 0 ? void 0 : _window4.googleLoginClientId;
  const facebookId = (_window$Odigeo = window.Odigeo) === null || _window$Odigeo === void 0 || (_window$Odigeo = _window$Odigeo.SessionScope) === null || _window$Odigeo === void 0 || (_window$Odigeo = _window$Odigeo.social) === null || _window$Odigeo === void 0 ? void 0 : _window$Odigeo.facebookAppId;
  const marketingPortal = (_window$Odigeo2 = window.Odigeo) === null || _window$Odigeo2 === void 0 || (_window$Odigeo2 = _window$Odigeo2.SessionScope) === null || _window$Odigeo2 === void 0 ? void 0 : _window$Odigeo2.mktPortal;
  const errorHandler = createErrorHandler(window.Odigeo);
  const frontendAPIClientProps = createFrontendAPIClientProps({
    logger: SessionScope.logger,
    tokenFallback: SessionScope.visitInformation
  });
  const {
    queryClient
  } = frontendAPIClientProps;
  const appProviderProps = _objectSpread(_objectSpread({}, optionsProps), {}, {
    routingProps: {
      routeMatcher,
      pageHandler,
      odigeoNavigate: odigeoNavigate
    },
    baseProps: {
      errorHandler: errorHandler,
      logger: SessionScope.logger,
      i18nextOptions: i18nextOptions,
      clientInterface: SessionScope.interface,
      currenyFormat: locale.currenyFormat,
      flow,
      flowActions: {
        goToHome,
        openFlightSummary
      },
      featureVariationsInput,
      context: getAppContext(),
      facebookId,
      googleClientId,
      marketingPortal
    },
    appErrorProps: {
      invalidateQueries: () => queryClient.invalidateQueries(),
      logService: '/frontend-api',
      frontVersion: SessionScope.oneFrontVersion
    },
    frontendAPIClientProps
  });
  if (disableTracking) {
    appProviderProps.baseProps = _objectSpread(_objectSpread({}, appProviderProps.baseProps), {}, {
      storageClient: {}
    });
  } else {
    const {
      storageClient,
      customDimensionsRepository,
      pageTracker,
      datalayerTrackingClient,
      eCommerceTrackingClient,
      trackingParamsRepository,
      dataMeshTrackingClient,
      thirdPartyTrackingAgent
    } = await createAppProviderCoreProps({
      brandCode,
      locale,
      isNativeWebView,
      trackingAgent: {
        trackPage,
        trackSurvey,
        routeMatcher,
        routePageMap: {}
      }
    });
    appProviderProps.baseProps = _objectSpread(_objectSpread({}, appProviderProps.baseProps), {}, {
      storageClient,
      pageTracker,
      customDimensionsRepository,
      datalayerTrackingClient,
      eCommerceTrackingClient,
      trackingParamsRepository,
      dataMeshTrackingClient,
      thirdPartyTrackingAgent
    });
  }
  return appProviderProps;
};